export default __webpack_public_path__ + "static/media/BALL.abd8de4d.png";